import { Lock } from 'lucide-react';
import { useToast } from '../../contexts/ToastContext';

interface NonSplitToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** hasBootcampAccess(profile) — W/O Split is a bootcamp-only feature */
  hasAccess: boolean;
}

/**
 * "W/O Split" (non-split orders) checkbox shared by New Broker Summary, New Broker Transaction and Trade Footprint.
 * Hover shows a "Menu khusus bootcamp" tooltip for everyone; users without bootcamp access
 * also get a lock icon, can't tick it, and get a toast when they click.
 */
export function NonSplitToggle({ checked, onChange, hasAccess }: NonSplitToggleProps) {
  const { showToast } = useToast();

  return (
    <label
      className="group relative flex items-center gap-1.5 cursor-pointer hover:opacity-80 transition-opacity"
      aria-label="W/O Split — menu khusus bootcamp"
      onClick={(e) => {
        if (!hasAccess) {
          e.preventDefault();
          showToast({
            type: 'warning',
            title: 'Menu Khusus Bootcamp',
            message: 'Fitur W/O Split hanya tersedia untuk user yang sudah mengikuti bootcamp.'
          });
        }
      }}
    >
      <input
        type="checkbox"
        checked={hasAccess ? checked : false}
        onChange={(e) => {
          if (!hasAccess) {
            e.preventDefault();
            return;
          }
          onChange(e.target.checked);
        }}
        className="w-3.5 h-3.5 rounded border-[#3a4252] text-primary focus:ring-primary cursor-pointer"
      />
      <span className="text-xs text-foreground whitespace-nowrap">W/O Split</span>
      {!hasAccess && <Lock className="w-3 h-3 text-muted-foreground flex-shrink-0" />}
      <span
        role="tooltip"
        className="pointer-events-none absolute left-0 top-full mt-1 z-50 whitespace-nowrap rounded-md border border-[#3a4252] bg-popover px-2 py-1 text-[11px] font-medium text-popover-foreground shadow-lg opacity-0 group-hover:opacity-100 transition-opacity"
      >
        Menu khusus bootcamp
      </span>
    </label>
  );
}
